import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetScheduleApiType, GetUserListApiType, UpdateCounselerScheduleRequest } from 'models/Admin/AdminPaginationTypes';

class AdminManageUserJoinPageApi {
    async getUserList(page: number | null, selectedSearchFilter: number | null, searchValue: string | null, token: string, level: number | null): Promise<GetUserListApiType> {
        let url = `${apiPaths.getUserList}?page=${page}&limit=${11}`;

        if (selectedSearchFilter !== null) {
            url += `&searchType=${selectedSearchFilter}`;
        }

        if (searchValue !== null) {
            url += `&searchKeyword=${searchValue}`;
        }

        if (level !== null) {
            url += `&level=${level}`;
        }

        try {
            const resopnse = await axios.get(url, { headers: tokenHeader(token) });
            return resopnse.data;
        } catch (error) {
            throw error;
        }
    }

    async getCounselerSchedule(userId: string, token: string): Promise<GetScheduleApiType> {
        let url = `${apiPaths.getCounselerSchedule}/${userId}`;
        try {
            const resopnse = await axios.get(url, { headers: tokenHeader(token) });
            return resopnse.data;
        } catch (error) {
            throw error;
           }
    }

    async updateCounselerSchedule(updateScheduleData: UpdateCounselerScheduleRequest, token: string): Promise<GetScheduleApiType> {
        try {
            const resopnse = await axios.put(`${apiPaths.updateCounselerSchedule}`, updateScheduleData, { headers: tokenHeader(token) });
            return resopnse.data;
        } catch (error) {
            throw error;
        }
    }
}

export const adminManageUserJoinPageApi = new AdminManageUserJoinPageApi();
